"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _jsxFileName = "/Users/newuser/Documents/GitHub/wordsby-components/src/components/psychic-window/index.js";
var robot = false;
var postRobot;

if (typeof window !== "undefined") {
  postRobot = require("post-robot");
} else {
  postRobot = false;
}

var PsychicWindow =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(PsychicWindow, _Component);

  function PsychicWindow(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.listener = false;
    _this.iframe = _react.default.createRef();
    _this.loading = _react.default.createRef();
    _this.wait = _this.props.wait ? _this.props.wait : 0;
    _this.scrollUpOffset = _this.props.scrollUpOffset ? _this.props.scrollUpOffset : 0;
    _this.state = {
      navigated: false
    };

    if (!!postRobot && robot.cancel) {
      robot.cancel();
    }

    _this.url = new _urlParse.default(_this.props.url);

    _this.updateIframe = function () {
      if (!postRobot || typeof window === "undefined") return;

      if (!!_this.state.navigated && _this.props.scrollUp) {
        var scrollTopDistance = _this.iframe.getBoundingClientRect().top + document.documentElement.scrollTop + _this.scrollUpOffset;

        window.scrollTo(0, scrollTopDistance);
      }

      postRobot.send(_this.iframe, "iframeDomElementLoaded", {
        css: _this.props.windowCSS
      }, {
        domain: _this.url.origin
      }).then(function (_ref) {
        var url = _ref.data.url;
        var args = {
          url: url,
          iframe: _this.iframe
        };

        if (_this.props.onNavigate && _this.state.navigated) {
          _this.props.onNavigate(args);
        } else if (_this.props.onLoad && !_this.state.navigated) {
          _this.props.onLoad(args);
        }

        _this.setState({
          navigated: true
        });
      });
    };

    return _this;
  }

  var _proto = PsychicWindow.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.iframe.onload = function () {
      return _this2.updateIframe();
    };

    if (!this.listener && !!postRobot) {
      this.listener = postRobot.on("iframeHeightChanged" + this.url.pathname, function (_ref2) {
        var height = _ref2.data.height;
        setTimeout(function () {
          _this2.loading.style.opacity = 0;
          setTimeout(function () {
            _this2.iframe.style.display = "unset";
            _this2.loading.style.display = "none";
            _this2.iframe.style.height = height + "px";
            _this2.iframe.style.opacity = 1;
          }, 300);
        }, _this2.wait);
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (!!this.listener && !!postRobot) {
      this.listener.cancel();
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    if (typeof window === "undefined") return this.props.children;
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("iframe", {
      scrolling: "no",
      ref: function ref(r) {
        return _this3.iframe = r;
      },
      src: this.props.url,
      title: this.props.url,
      style: {
        border: "none",
        width: "100%",
        height: 0,
        overflowY: "hidden",
        opacity: 0,
        transition: "opacity .25s ease-in"
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121
      },
      __self: this
    }), _react.default.createElement("div", {
      className: "loading",
      ref: function ref(r) {
        return _this3.loading = r;
      },
      style: {
        transition: "opacity .1s ease",
        opacity: 1
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 135
      },
      __self: this
    }, this.props.children));
  };

  return PsychicWindow;
}(_react.Component);

exports.default = PsychicWindow;